module.exports = __webpack_public_path__ + "static/media/edresult4.2fc3a06a.png";